import { encodeFunctionData, createPublicClient, http } from 'viem';

import { abiDailyCheckIn } from '../config/abi.contract';
import useWrappedRPC from './useWrappedRPC';
import { validateDailyCheckinTransaction } from '../services/transaction.service';
import environments from '../utils/environments';

const { PUBLIC_RPC_URL, DAILY_CHECKIN_CONTRACT_ADDRESS } = environments;

function useDailyCheckIn() {
  const { sendTransactionWithGas } = useWrappedRPC();

  const dailyCheckIn = async () => {
    try {
      const publicClient = createPublicClient({
        chain: process.env.REACT_APP_CHAIN_ID,
        transport: http(PUBLIC_RPC_URL),
      });

      const checkInPrice = await publicClient.readContract({
        address: DAILY_CHECKIN_CONTRACT_ADDRESS,
        abi: abiDailyCheckIn,
        functionName: 'checkInPrice',
      });

      const data = encodeFunctionData({
        abi: abiDailyCheckIn,
        functionName: 'checkIn',
        args: [],
      });

      const txUiConfig = {
        header: `Daily`,
        description: `Daily checkin`,
        buttonText: `Checkin`,
      };

      // Construct transaction request
      const transactionRequest = {
        to: DAILY_CHECKIN_CONTRACT_ADDRESS,
        data: data,
        value: checkInPrice,
      };

      const { txReceipt } = await sendTransactionWithGas(transactionRequest, txUiConfig);
      if (!txReceipt) throw new Error('Transaction failed on blockchain');

      const backendResponse = await validateDailyCheckinTransaction({ transactionHash: txReceipt.hash });

      return {
        success: true,
        message: 'Verify successful',
        data: backendResponse.data,
      };
    } catch (error) {
      console.error('Checkin transaction failed:', error);
      return { success: false, message: error.message };
    }
  };

  return { dailyCheckIn };
}

export default useDailyCheckIn;
